import { AfterViewInit, Component, inject, signal, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ServiceWorkerService } from '@core/services/serviceworker.service';
import { ThemeService } from '@core/services/theme.service';
import { FontSizeService } from '@core/services/font-size.service';
import { AppTranslateLanguageService } from '@core/services/app-translate-language.service';
import { DirectionService } from '@core/services/direction.service';
import { SharedModule } from '@shared/shared.module';
import { UpdateNotificationComponent } from './layout/components/update-notification/update-notification.component';
import { KlGlobalLoaderComponent } from './shared/components/kl-global-loader/kl-global-loader';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SharedModule, UpdateNotificationComponent, KlGlobalLoaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit, AfterViewInit {
  private readonly swService = inject(ServiceWorkerService);
  private readonly themeService = inject(ThemeService);
  private readonly fontSizeService = inject(FontSizeService);
  private readonly translateLanguage = inject(AppTranslateLanguageService);
  private readonly directionService = inject(DirectionService);

  protected readonly title = signal('JRetail Basic');

  ngOnInit(): void {
    this.swService.checkForUpdates();
    this.translateLanguage.restoreStoredLanguage();
    this.translateLanguage.syncPrimeNgTranslations();
  }

  ngAfterViewInit(): void {
    setInterval(() => this.hideThirdPartyLicenseOverlays(), 1000);
  }

  /** Hides Wijmo / Syncfusion trial license DOM overlays (legacy Basic parity). */
  private hideThirdPartyLicenseOverlays(): void {
    document.querySelectorAll('a').forEach((element) => {
      const host = (element.host || '').toLowerCase();
      if (host.includes('syncfusion.com')) {
        element.style.display = 'none';
        const parentElement = element.parentElement;
        if (parentElement) {
          parentElement.style.display = 'none';
        }
      }
    });

    document.querySelectorAll('body > div').forEach((element) => {
      if (element.textContent?.includes('trial version of Syncfusion Essential Studio')) {
        (element as HTMLElement).style.display = 'none';
      }
    });
  }

  testSentry(): void {
    throw new Error('Test Sentry');
  }
}
